export const LocalStorageKEYS = {
    CustomerDetails: 'CustomerDetails',
    GlobalParams: 'GlobalParams',
    activityFlow: 'activityFlow',
    CountDownTimer: 'CountDownTimer'
}
export const setLocalStorage = (step, item) => {

    localStorage.setItem(step, JSON.stringify(item))
}
export const useLocalStorage = () => {
    const getLocalStorage = (step) => {
        const local = localStorage.getItem(step)
        if (local !== null && local !== undefined && local !== 'undefined') {
            return JSON.parse(local)
        }
        return undefined
    } 
    const setLocalStorage = (step ,item) => {

       localStorage.setItem(step, JSON.stringify(item))
    }
    const removeLocalStorage = (step) => {
        localStorage.removeItem(step)
    }
    return [getLocalStorage, setLocalStorage, removeLocalStorage]
}

export const getLocalStoragKey = (localStoreName, key) => {
    const storage = localStorage.getItem(localStoreName)
    const localStorageState = storage && storage!=='undefined' ? JSON.parse(storage) : undefined;
    return localStorageState && key ? localStorageState[key] : localStorageState;
    
}


export const ClearLocalStorage = () => {
    localStorage.clear();
}

// export const GetLocalStorageState = () => {
//     const [getLocalStorage] = useLocalStorage();
    
//     const localStorageState = getLocalStorage('step') ? getLocalStorage('step') : undefined;
//     const localStorageSelectedActivity = localStorageState ? localStorageState.selectedActivity : undefined
//     const localStorageCustomerDetail = getLocalStorage('customerDetails') !== null ? getLocalStorage('customerDetails') : undefined;
//     const localStorageGlobalParams = getLocalStorage('globalParams') !== null ? getLocalStorage('globalParams') : undefined;
//     const localStorageVisitors = localStorageState ? localStorageState.visitors : undefined;
//     const localStorageActivityTiming = localStorageState ? localStorageState.timing : undefined;
//     const localStorageCustomerDetails = localStorageCustomerDetail ? localStorageCustomerDetail : undefined 
//     const localStorageSelectedActivities = localStorageState ? localStorageState.selectedActivities : undefined;
//     return [localStorageState, localStorageGlobalParams, localStorageSelectedActivities, localStorageVisitors, localStorageSelectedActivity, localStorageActivityTiming, localStorageCustomerDetails]
// }


